import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import cns from '../../node_modules/classnames/index.js';

function isLinkActive(link, pathname, matchPath) {
    if (link === '/')
        return false;
    return link === pathname || matchPath(pathname, link);
}
const Item = function Item({ location = { pathname: '' }, history = null, active = false, children = null, className = null, content = null, link = null, onClick = null, icon, matchPath, }) {
    const pathname = (location && location.pathname) || null;
    let itemActive = active;
    if (!itemActive && link && pathname) {
        itemActive = isLinkActive(link, pathname, matchPath);
    }
    const classes = cns('sidebar__item', {
        'sidebar__item--active': itemActive,
    }, className);
    const handleClick = useCallback((event) => {
        if (link) {
            history === null || history === void 0 ? void 0 : history.push(link);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [history, link, onClick]);
    return (jsxs("div", { className: classes, onClick: handleClick, role: "presentation", children: [jsx("div", { className: "sidebar__item__icon", children: icon }), jsx("div", { className: "sidebar__item__text", children: content || children })] }));
};

export { Item as default, isLinkActive };
